import React, {useEffect, useState} from 'react';

import Form from "react-bootstrap/Form";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { countries } from 'countries-list';

import SchoolListing from "./SchoolListing";
import Button from "react-bootstrap/Button";
import useGoogleSheets from "use-google-sheets";


//https://sarasch--partialdev.sandbox.lightning.force.com/lightning/setup/ObjectManager/Contact/FieldsAndRelationships/view

const FirstStep= (props) => {
    const {formData, setFormData, handleChange, SubmitFirstStep, validFirstStep, checkDuplicateSSN, messageSSN, returningStatus, setReturningStatus, setValidFirstStep, sendEmail} = props;

    const [sheetData, setSheetData] = useState(null);


    const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;
    const sheetId = "1xGSyQqVu8WQKDs4igG018X487OIkptHD_msC5y9KfMU";

    const { data } = useGoogleSheets({
        apiKey: apiKey,
        sheetId: sheetId,
        sheetsOptions: [{ id: 'Students' }],
    });

    useEffect(() => {
        if (data) {
            setSheetData(data[0]);
        }
    }, [data]);



    const top100Countries = Object.values(countries)
        .map(country => country.name)
        .slice(0, 100); // Adjust the slice as needed

const validateSSN = (event) => {
    const { value } = event.target;
    event.target.setCustomValidity('');

    const invalidSSN =  ['000-00-0000', '111-11-1111'
        ,'222-22-2222'
        ,'333-33-3333'
        ,'444-44-4444'
        ,'555-55-5555'
        ,"666-66-6666"
        ,'777-77-7777'
        ,'888-88-8888'
        ,'999-99-9999',
        '123-45-6789',
        '987-65-4321',
        '012-34-5678'];


    const cleaned = ('' + value).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{0,3})(\d{0,2})(\d{0,4})$/);
    if (match ) {
        let newSSN= [match[1], match[2], match[3]].filter(Boolean).join('-');
        setFormData({
            ...formData,
            ssn: newSSN
        })
        if (value.length> 10   && invalidSSN.includes(value)){
            event.target.setCustomValidity('Invalid SSN');
            return false;
        }

            if (value.length === 11   ) {
               checkDuplicateSSN(newSSN);
                CheckNameAndDOB(event);
            }


    }
}
    const CheckNameAndDOB = (event) => {
        const { id, value } = event.target; // id will be "dob", "lastName", "ssn", etc.

        setReturningStatus('doesntexist');

        setFormData(prev => {
            const next = { ...prev, [id]: value };
            const lastNameValid = Boolean(next.lastName && next.lastName.trim().length > 0);
            const dobValid = Boolean(next.dob); // input type="date" returns 'YYYY-MM-DD' or ''

            const ssn = id === 'ssn' ? value : next.ssn;

            if (dobValid && lastNameValid && sheetData?.data) {
                for (const item of sheetData.data) {
                    if (item.Last?.toLowerCase().trim() === next.lastName?.toLowerCase().trim()) {
                        const sheetDob = new Date(item.DOB);
                        const formDob = new Date(`${next.dob}T00:00:00`);

                        if (sheetDob.getTime() === formDob.getTime() && String(ssn).slice(-4) == String(item.SSN)) {
                            if (item.Status === 'Rejected') {
                                setReturningStatus('rejected');
                                sendEmail('rejected', 'Rejected from Google Sheet ');
                            } else if (item.Status === 'Approved') {
                                setReturningStatus('approved');
                            }
                        }
                    }
                }
            }

            return next; // important: return the new state
        });
    };

        return (
        <>
<Row   >
    {/*<h1>  Sara Schenirer Late Dual Credit Course Registration</h1>*/}

    <p>Please fill out all the information below before selecting your school and grade.   <br/>You will then be prompted to select your courses and submit payment.<br/><strong>Your registration is not confirmed until you receive a confirmation email.</strong></p>
    <p><i>Note: Session will time out after 30 minutes.</i></p>
<p>Course registration closes on Friday, October 30th, 2026.</p>
            <p> For any questions, reach out to Mrs. Lieba Berger at <a href="mailto:lberger@sarasch.com">lberger@sarasch.com</a></p>
</Row>
            <Row className="mb-1 mt-4 text-start">
                <h2>Personal Information</h2>
            </Row>
            <Row className="mb-3 text-start">
                <div className="mt-2 mb-2 small">
                    Please provide your full legal name as it appears on your government ID.

                </div>
                <Form.Group as={Col} md="4" controlId="firstName">
                    <Form.Label>First name</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="First name"
                        onChange={handleChange}
                        value={formData.firstName || ""}

                    />

                </Form.Group>
                <Form.Group as={Col} md="4" controlId="middleName">
                    <Form.Label>Middle name</Form.Label>
                    <Form.Control

                        type="text"
                        placeholder="Middle name"
                        onChange={handleChange}
                        value={formData.middleName || ""}
                    />
                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                </Form.Group>  <Form.Group as={Col} md="4" controlId="lastName">
                <Form.Label>Last name</Form.Label>
                <Form.Control
                    required
                    type="text"
                    placeholder="Last name"
                    onChange={CheckNameAndDOB}
                    value={formData.lastName || ""}
                />

            </Form.Group>

            </Row>
            <Row className="mb-3 text-start">
                <Form.Group as={Col} md="6" controlId="ssn">
                    <Form.Label>U.S. Social Security Number</Form.Label>
                    <Form.Control type="text" placeholder="XXX-XX-XXXX" required   value={formData.ssn || ""}     maxLength="11" minLength="11"    onChange={validateSSN}
                    pattern="^(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0000)\d{4}$" />
                    <div style={{ color: 'red' }}><small>Please have your social security card on hand to verify the SSN. <br /> Your application will not be processed with an invalid SSN.</small></div>
                    <Form.Control.Feedback type="invalid">
                        Invalid
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="usCitizen">
                    <Form.Label>Are you a US Citizen?</Form.Label>
                    <div key={`inline-radio`} className="mb-3">
                    <Form.Check type="radio" name="usCitizen" id="usCitizen_01" value="true" required  inline    checked={formData.usCitizen === "true"}    label="Yes"     onChange={handleChange} />
                    <Form.Check type="radio" name="usCitizen" value="false"  id="usCitizen_00" required  inline     checked={formData.usCitizen === "false"}     label="No"  onChange={handleChange} />
                    </div>
                </Form.Group>

                <Form.Group as={Col} md="6" controlId="dob">
                    <Form.Label>Date of Birth</Form.Label>
                    <Form.Control type="date" placeholder="mm/dd/YYYY" required
                                  value={formData.dob || ""}
                                  name="dob"
                                  min={(new Date(new Date().setFullYear(new Date().getFullYear() - 50))).toISOString().split('T')[0]}
                                  max={(new Date(new Date().setFullYear(new Date().getFullYear() - 13))).toISOString().split('T')[0]}   onChange={CheckNameAndDOB} />
                    <div className="invalid-feedback">
                        Please enter a valid birth date.
                    </div>

                </Form.Group>

                <Form.Group as={Col} md="6" controlId="gender">
                    <Form.Label>Gender</Form.Label>
                    <div key={`inline-radio`} className="mb-3">
                        <Form.Check
                            type="radio"
                            name="gender"
                            value="male"
                            required
                            inline
                            label="Male"
                            id="gender_0"
                            checked={formData.gender === "male"}
                            onChange={handleChange}
                        />

                        <Form.Check
                            type="radio"
                            name="gender"
                            value="female"
                            required
                            inline
                            id="gender_1"
                            checked={formData.gender === "female"}
                            label="Female"
                            onChange={handleChange}
                        />
                    </div>
                </Form.Group>

            </Row>
{returningStatus == 'rejected' && (
    <div  className="mt-4 alert alert-danger" >
                    Upon review of your high school transcript, your grade point average does not meet the college requirement to join the Dual Credit program.  <br />Unfortunately, we are unable to accommodate you at this time.


                </div>
)}

            {messageSSN && <div className="alert alert-primary mt-4 mb-4 ">{messageSSN}</div>}
            {returningStatus != 'rejected'  && messageSSN == '' && (

                <>
            <Row className="mb-3 text-start">
                <label>Email</label>
                <div className="mb-2 small mt-2"><p className="mb-0">This must be a personal, not school, email address. All future correspondence, including the itemized receipt for this registration, will be sent to this email address.</p>
                    <p className="fst-italic">Due to restrictions with Yahoo and AOL addresses, a Gmail address is preferred.</p>
                </div>

                <Form.Group as={Col} md="6" controlId="email">
                    <Form.Control type="email" placeholder="Email" required
                                  value={formData.email || ""}
                                  onChange={handleChange}/>
                    <Form.Control.Feedback type="invalid">
                        Please provide a valid email.
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="confirmEmail">
                    <Form.Control type="email" placeholder="Confirm Email"  isInvalid={ (formData.email && formData.confirmEmail) && (formData.email !== formData.confirmEmail)}
                                  onChange={handleChange}
                                  value={formData.confirmEmail || ""}
                                  required/>

                    <Form.Control.Feedback type="invalid">
                        Email must match
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
            <Row className="mb-3 text-start">
                <Form.Group as={Col} md="4" controlId="phone">
                    <Form.Label>Home Phone</Form.Label>

                    <Form.Control
                        type="tel"
                        placeholder=" Phone"
                        name="phone"
                        required
                        value={formData.phone || ""}
                        pattern="(\d{3}[-.\s]?\d{3}[-.\s]?\d{4}|\(\d{3}\)\s?\d{3}[-.\s]?\d{4})"
                        onChange={handleChange}
                    />


                    <Form.Control.Feedback type="invalid">
                        Please provide a valid phone.
                    </Form.Control.Feedback>
                </Form.Group>
   <Form.Group as={Col} md="4" controlId="cell">
                    <Form.Label>Cell Phone</Form.Label>
       <Form.Control
           type="tel"
           placeholder="Cell Phone"
           name="cell"
           required
           value={formData.cell || ""}
           pattern="(\d{3}[-.\s]?\d{3}[-.\s]?\d{4}|\(\d{3}\)\s?\d{3}[-.\s]?\d{4})"
           onChange={handleChange}
       />
                    <Form.Control.Feedback type="invalid">
                        Please provide a valid phone.
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="4" controlId="allowTexting">
                    <Form.Label> Does this phone have texting?</Form.Label>
                    <div key={`inline-radio`} className="mb-3">
                        <Form.Check type="radio" name="allowTexting"  id="allowTexting_00" value="yes" required  inline     checked={formData.allowTexting === "yes"} label="Yes"     onChange={handleChange} />
                        <Form.Check type="radio" name="allowTexting"  id="allowTexting_01" value="no" required  inline     checked={formData.allowTexting === "no"}  label="No"  onChange={handleChange} />
                    </div>
                </Form.Group>
            </Row>
            <Row className="mb-3 text-start">
                <Form.Group as={Col} md="12" controlId="address">
                    <Form.Label>Address</Form.Label>
                    <Form.Control type="text" placeholder="Address" required  value={formData.address ||""}        onChange={handleChange} />
                    <Form.Control.Feedback type="invalid">
                        Please provide a valid address.
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="city">
                    <Form.Label>City</Form.Label>
                    <Form.Control type="text" placeholder="City" required    value={formData.city ||""}       onChange={handleChange} />
                    <Form.Control.Feedback type="invalid">
                        Please provide a valid city.
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="state">
                    <Form.Label>State</Form.Label>
                    <Form.Control type="text" placeholder="State" required    value={formData.state ||""}      onChange={handleChange} />
                    <Form.Control.Feedback type="invalid">
                        Please provide a valid state.
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="zip">
                    <Form.Label>Zip</Form.Label>
                    <Form.Control type="text" placeholder="Zip" required     pattern="[0-9]*"     value={formData.zip ||""}      onChange={handleChange}/>
                    <Form.Control.Feedback type="invalid">
                        Please provide a valid zip.
                    </Form.Control.Feedback>
                </Form.Group>
   <Form.Group as={Col} md="6" controlId="country">
       <Form.Label>Country</Form.Label>
       <Form.Select required value={formData.country || ""} onChange={handleChange}>
           {["United States", "Canada", "Israel", "Mexico", ...top100Countries].map((country, index) => (
               <option key={index} value={country}>
                   {country}
               </option>
           ))}
       </Form.Select>
       <Form.Control.Feedback type="invalid">
           Please provide a valid country.
       </Form.Control.Feedback>
   </Form.Group>
            </Row>
            <Row className="mb-1 mt-5 text-start">

                <h3>Parent/Legal Guardian Information               </h3>
            </Row>
            <Row className="mb-3 mt-4 text-start">
                <Form.Group as={Col} md="6" controlId="guardianFirstName">
                    <Form.Label>First name</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="First name"
value={formData.guardianFirstName ||""}
                        onChange={handleChange}
                    />

                </Form.Group>
                <Form.Group as={Col} md="6" controlId="guardianLastName">
                <Form.Label>Last name</Form.Label>
                <Form.Control
                    required
                    type="text"
                    placeholder="Last name"
                    value={formData.guardianLastName ||""}
                    onChange={handleChange}
                />

            </Form.Group>
            </Row>
            <Row className="mb-3 mt-4 text-start">
                <Form.Group as={Col} md="6" controlId="guardianPhone">
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="Phone"
                        pattern="(\d{3}[-.\s]?\d{3}[-.\s]?\d{4}|\(\d{3}\)\s?\d{3}[-.\s]?\d{4})"
                        value={formData.guardianPhone ||""}
                        onChange={handleChange}
                    />

                </Form.Group>
                <Form.Group as={Col} md="6" controlId="guardianEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control
                    required
                    type="email"
                    placeholder="Email"
                    value={formData.guardianEmail ||""}
                    onChange={handleChange}
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                    minLength="10"
                />

            </Form.Group>      </Row>
            <Row className="mb-1   text-start">
                <Form.Group as={Col} md="12" controlId="guardianRelationship">
                    <Form.Label>Relationship</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="Relationship"
                        value={formData.guardianRelationship ||""}
                        onChange={handleChange}
                    />

                </Form.Group>
            </Row>
            <Row className="mb-1  mt-5 text-start">

                <h3>High School Information
                </h3>
            </Row>
            <Row className="mb-3 text-start">
                <Form.Group as={Col} md="9" controlId="school" >
                    <Form.Label>School</Form.Label>
                    <SchoolListing formData={formData} setFormData={setFormData} sendEmail={sendEmail} returningStatus={returningStatus} />



                </Form.Group>
                <Form.Group as={Col} md="3" controlId="grade">
                    <Form.Label>Current Grade</Form.Label>

                    <Form.Select   onChange={handleChange} required
                                   value={formData.grade}
                    >
                    <option value="">Select</option>
                    <option value="11">11</option>
                    <option value="12">12</option>

                </Form.Select>
            </Form.Group>


                {returningStatus == 'doesntexist'  && (formData.school.requireRecord == 'Yes all' || formData.school.requireRecord == 'Yes some') && (
                    <div  className="mt-4 alert alert-danger" >
                        It seems you are attempting to register for Dual Credit courses for the upcoming school year. Our records indicate that you have not yet applied to the program.
                        <br/>
                        <strong> In order to register for courses, an application and notice of acceptance are necessary.</strong>
                        <br />
                        To submit an application now, please <a href="https://sarasch.com/dual-application" target="_blank">click here</a>. Please be aware you will be charged a $25 late fee.     <br /> Once your application is processed, you will receive an email informing you of your acceptance status and next steps.
                    </div>
                )}
            </Row>
                {!validFirstStep   && !(returningStatus == 'doesntexist'  && (formData.school.requireRecord == 'Yes all' || formData.school.requireRecord == 'Yes some')) && (
            <Button type="button"  onClick={SubmitFirstStep}>Next></Button>
            )}
   </>
            )}
            </>
            );
            }



            export default FirstStep;
